import { useMutation } from '@zg-rentals/react-query5';
import { useDispatch, useSelector } from 'react-redux';
import { updateIsOnboardingPageViewedApi } from '../api';
import { emailSelector } from '../../selectors';

/**
 * @returns {import('react-query').UseMutationResult}
 */
export default function useCreateCappsUser() {
  const dispatch = useDispatch();
  const email = useSelector(emailSelector);
  return useMutation({
    mutationFn: () => dispatch(updateIsOnboardingPageViewedApi({ email })),
  });
}
